import { render, staticRenderFns } from "./club-member-details.vue?vue&type=template&id=2179869f"
import script from "./club-member-details.vue?vue&type=script&lang=js"
export * from "./club-member-details.vue?vue&type=script&lang=js"
import style0 from "./club-member-details.vue?vue&type=style&index=0&id=2179869f&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2179869f')) {
      api.createRecord('2179869f', component.options)
    } else {
      api.reload('2179869f', component.options)
    }
    module.hot.accept("./club-member-details.vue?vue&type=template&id=2179869f", function () {
      api.rerender('2179869f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/club-member/club-member-details/club-member-details.vue"
export default component.exports